/*
 * Restyle Agenorie: correzioni di comportamento su Aurora.
 */

// Aurora misura la larghezza del menu una sola volta all'avvio, spesso prima che il font
// sia caricato: il menu risulta più stretto del reale e può finire sopra il logo.
// Rifacciamo la misura quando i font sono pronti e a ogni ridimensionamento.
(function () {
  function remeasureHeaderNav() {
    var nav = document.querySelector('[data-desktop-nav]');
    var header = nav;
    while (header && typeof header.setNavItems !== 'function') header = header.parentElement;
    if (!header) return;
    // Misura sempre nel layout "menu visibile": con l'hamburger attivo il logo si sposta
    // a sinistra e il calcolo di Aurora darebbe un risultato sbagliato
    var grid = header.querySelector('.header__grid');
    if (grid) grid.removeAttribute('fit-nav');
    if (header.burgerIcon) header.burgerIcon.remove();
    nav.hidden = false;
    header.setNavItems();
    header.checkIsNavContainerFitAllLinks();
  }

  function schedule() {
    requestAnimationFrame(remeasureHeaderNav);
  }

  if (document.fonts && document.fonts.ready) document.fonts.ready.then(schedule);
  window.addEventListener('load', schedule);

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(schedule, 150);
  });
})();

// Sottocategorie delle collezioni: evidenzia quella della pagina corrente
(function () {
  var path = window.location.pathname.replace(/\/$/, '');
  document.querySelectorAll('.navigation-buttons__button-title').forEach(function (link) {
    var href = (link.getAttribute('href') || '').replace(/\/$/, '');
    if (href && path.endsWith(href)) link.classList.add('is-current');
  });
})();

// Iniziali ricamate (snippets/product-monogram.liquid)
(function () {
  // Il cliente scrive solo le lettere (anche accentate), da 1 a 6, in maiuscolo.
  function cleanInitials(value) {
    return value.toUpperCase().replace(/[^A-ZÀ-Ý]/g, '').slice(0, 6);
  }

  // Il punto tra le lettere viene sempre ricamato: ABC -> A.B.C
  function withDots(letters) {
    return letters.split('').join('.');
  }

  function letterCount(value) {
    return cleanInitials(value).length;
  }

  function setup(root) {
    var toggle = root.querySelector('[data-monogram-toggle]');
    var panel = root.querySelector('[data-monogram-panel]');
    var input = root.querySelector('[data-monogram-input]');
    var value = root.querySelector('[data-monogram-value]');
    var consent = root.querySelector('[data-monogram-consent]');
    var preview = root.querySelector('[data-monogram-preview]');
    var colorName = root.querySelector('[data-monogram-color-name]');
    var summary = root.querySelector('[data-monogram-summary]');
    var summaryText = root.querySelector('[data-monogram-summary-text]');
    var error = root.querySelector('[data-monogram-error]');
    var fields = root.querySelectorAll('[data-monogram-field]');

    function checked(group) {
      return root.querySelector('[data-monogram-group="' + group + '"]:checked');
    }

    function missing() {
      var list = [];
      if (!letterCount(input.value)) list.push('letters');
      ['style', 'color', 'position'].forEach(function (group) {
        if (!checked(group)) list.push(group);
      });
      if (!consent.checked) list.push('consent');
      return list;
    }

    function showMissing() {
      var list = missing();
      error.hidden = list.length === 0;
      error.querySelectorAll('[data-monogram-missing]').forEach(function (item) {
        item.hidden = list.indexOf(item.dataset.monogramMissing) === -1;
      });
      return list;
    }

    function render() {
      var style = checked('style');
      var color = checked('color');
      var position = checked('position');

      var embroidered = withDots(input.value);
      value.value = embroidered;
      preview.textContent = embroidered || 'A.B.C';
      preview.classList.toggle('is-placeholder', !input.value);
      preview.classList.toggle('monogram__preview--script', !!style && style.dataset.monogramStyle === 'script');
      preview.style.color = color ? color.dataset.monogramColor : '';
      colorName.textContent = color ? ': ' + color.value : '';

      var parts = [embroidered, style && style.value, color && color.value, position && position.value].filter(Boolean);
      summary.hidden = parts.length < 4;
      summaryText.textContent = parts.join(' · ');

      if (!error.hidden) showMissing();
    }

    function sync() {
      var on = toggle.checked;
      panel.hidden = !on;
      toggle.setAttribute('aria-expanded', on ? 'true' : 'false');
      // Campi disabilitati = non inviati: senza spunta l'ordine resta una camicia standard
      fields.forEach(function (field) { field.disabled = !on; });
      if (on) input.focus();
      else error.hidden = true;
    }

    input.addEventListener('input', function () {
      var clean = cleanInitials(input.value);
      if (input.value !== clean) input.value = clean;
      render();
    });
    root.addEventListener('change', function (event) {
      if (event.target !== toggle) render();
    });
    toggle.addEventListener('change', sync);

    // Con l'opzione attiva, niente carrello finché la personalizzazione non è completa e accettata.
    // In fase di cattura, prima del gestore di Aurora.
    var form = root.closest('form');
    if (form) {
      form.addEventListener('submit', function (event) {
        if (!toggle.checked) return;
        if (showMissing().length) {
          event.preventDefault();
          event.stopImmediatePropagation();
          error.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, true);
    }

    render();
  }

  document.querySelectorAll('[data-monogram]').forEach(setup);
})();
